import { createBrowserRouter } from 'react-router-dom';

import { SiteLayout } from '@/layouts/site-layout';
import { NotFoundPage } from '@/modules/errors/pages/not-found-page';
import { HomePage } from '@/modules/home/pages/home-page';

/**
 * Rotas do site público. Cada novo módulo em `src/modules` registra as suas
 * rotas aqui — a árvore de navegação fica legível num arquivo só.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <SiteLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
